// extracted by mini-css-extract-plugin
export var active = "_cp-c";
export var compactArrow = "_cp-5";
export var container = "_cp-0";
export var dot = "_cp-b";
export var dotContainer = "_cp-a";
export var hoverArrowButton = "_cp-7";
export var hoverArrowContainer = "_cp-6";
export var leftHoverArrowContainer = "_cp-8 _cp-6";
export var rightHoverArrowContainer = "_cp-9 _cp-6";
export var slide = "_cp-4";
export var sliderContainer = "_cp-1";
export var sliderContainerVisibleOverflow = "_cp-2";
export var sliderOverflow = "_cp-3";
export var vignetteBoth = "_cp-f";
export var vignetteLeft = "_cp-e";
export var vignetteRight = "_cp-d";